/* eslint-disable react/no-array-index-key */
import { Link } from "gatsby-plugin-react-i18next"
import { EColors, EFonts } from "libs/style/styling"
import React from "react"
import styled from "styled-components/macro"

interface Props {
  title?: string
  links: {
    title: string
    url: string
    target?: "_self"
  }[]
}

export const LinkList = (props: Props): JSX.Element => {
  return (
    <S_LinkList>
      <S_Head>
        <span className="title">{props.title}</span>
      </S_Head>
      <S_Body>
        {props.links.map((link, i) => (
          <React.Fragment key={i}>
            {link.target === "_self" && <Link to={link.url}>{link.title}</Link>}
            {!link.target &&
              (link.url ? (
                <a
                  href={link.url}
                  target={link.target ?? "_blank"}
                  rel="noreferrer"
                >
                  {link.title}
                </a>
              ) : (
                <span />
              ))}
          </React.Fragment>
        ))}
      </S_Body>
    </S_LinkList>
  )
}

export const S_LinkList = styled.div``

const S_Head = styled.div`
  height: 35px;
  > .title {
    color: white;
    font-size: 14px;
    font-family: ${EFonts.Bold};
    letter-spacing: -0.03em;
  }
  @media only screen and (min-width: 1260px) {
    height: 55px;
    > .title {
      font-size: 20px;
    }
  }
`

const S_Body = styled.div`
  display: flex;
  flex-direction: column;
  > a {
    font-size: 13px;
    text-decoration: none;
    color: ${EColors.WHITE};
    min-height: 16.5px;
    &:hover {
      color: ${EColors.ACC1_A};
    }
  }
  > a,
  span {
    min-height: 16.5px;
    &:not(:nth-last-child(1)) {
      margin: 0 0 15px 0;
    }
  }
  @media only screen and (min-width: 1260px) {
    > a {
      font-size: 15px;
    }
  }
`
